<template>
  <v-form ref="form" flat class="mt-8">
    <div class="d-flex">
      <v-row>
        <v-col cols="12" class="pb-0">
          <AutocompleteAcademicLevel
            v-model="academicLevel"
            clear-icon="mdi-close"
            item-text="title"
            item-value="id"
            label="Bộ môn"
            clearable
            outlined
            dense
            hide-details
            return-object
            class="required mb-6"
            :rules="[$rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <AutocompleteDivision
            class="required"
            v-model="division"
            item-text="title"
            item-value="id"
            label="Chương trình đào tạo"
            required
            dense
            outlined
            auto-select-first
            :disabled="get(academicLevel, 'id', '').length < 1"
            :rules="[$rules.required]"
            :filter="{ academicLevel: get(academicLevel, 'id', '') }"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <AutocompleteGrade
            return-object
            class="required"
            item-text="title"
            item-value="id"
            label="Học phần"
            required
            dense
            outlined
            auto-select-first
            :rules="[$rules.required]"
            @change="gradeChanged"
            :filters="gradeFilter"
            :disabled="(division || '').length < 1"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <AutocompleteDepartment
            v-model="department"
            label="Cơ sở"
            required
            dense
            outlined
            auto-select-first
            class="required"
            :rules="[$rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-select
            v-model="classMode"
            :items="classModeOptions"
            label="Hình thức học"
            required
            dense
            outlined
            class="required"
            :rules="[$rules.required]"
          />
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          v-if="totalDate !== null"
          v-model="totalDate"
          label="Tổng số buổi học"
          outlined
          required
          dense
          disabled
        >
        </v-text-field>
      </v-col>
    </v-row>
    <div class="mb-6">
      <DateIOSPicker
        :date.sync="beginningDate"
        label="Ngày bắt đầu"
        dense
        outlined
        class="required"
        :rules="[$rules.required, $rules.date]"
      />
    </div>

    <v-text-field
      ref="title"
      v-model="title"
      label="Tên lớp"
      placeholder="Nhập tên lớp học"
      outlined
      required
      dense
      class="required"
      :rules="[$rules.required, titleRule]"
    >
    </v-text-field>
    <v-textarea ref="description" v-model="description" label="Mô Tả" hide-details outlined />
  </v-form>
</template>
<script>
import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision'
import AutocompleteDepartment from '@/components/basic/input/AutocompleteDepartment'
import { textHelpers } from '@/helpers/TextHelper.js'
import AutocompleteAcademicLevel from '../input/AutocompleteAcademicLevel.vue'
import { mapState } from 'vuex'

export default {
  components: {
    AutocompleteGrade,
    AutocompleteDivision,
    DateIOSPicker,
    AutocompleteAcademicLevel,
    AutocompleteDepartment,
  },
  props: {
    classData: {
      type: [Object],
      required: true,
      default: () => {},
    },
    gradeData: Object,
    courseData: Object,
  },
  data: () => ({
    valid: true,
    course: '',
    grade: {},
    division: '',
    title: '',
    description: '',
    beginningDate: null,
    totalDate: null,
    academicLevel: {},
    department: null,
    classMode: 'offline',
    classModeOptions: [
      { text: 'Trực tiếp (offline)', value: 'offline' },
      { text: 'Trực tuyến (online)', value: 'online' },
      { text: 'Kết hợp (hybrid)', value: 'hybrid' },
    ],
    titleRule: (v) => {
      return isEmpty(v) || !String(textHelpers.removeSpaces(v)).includes(' ') || 'Tên lớp không chứa khoảng trống'
    },
    get,
  }),
  computed: {
    getCourseItems() {
      return this.grade ? this.grade.courses : []
    },
    gradeFilter() {
      return { division: this.division }
    },
    ...mapState({
      academicLevels(state) {
        return state['AcademicLevel'].academics
      },
    }),
  },
  methods: {
    getCourseFilter() {
      return { grade: get(this.grade, 'id', null) }
    },
    gradeChanged(grade) {
      this.grade = grade
      this.totalDate = get(this.grade, 'totalDate', 0)
    },
    reset() {
      this.$refs.form.reset()
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetDefault() {
      if (this.classData) {
        this.code = this.classData.code
        this.title = this.classData.title
        this.course = this.courseData || this.classData.course
        this.grade = this.gradeData || this.classData.grade
        this.description = this.classData.description
        this.beginningDate = this.classData.beginningDate
        this.department = this.classData.department
        this.classMode = get(this.classData, 'metadata.classMode', 'offline')
      } else {
        this.code = ''
        this.title = ''
        this.course = null
        this.grade = null
        this.description = ''
        this.beginningDate = null
        this.department = null
        this.classMode = 'offline'
      }
    },
    getData() {
      return {
        description: this.description,
        division: this.division,
        grade: this.grade.id,
        code: this.code,
        title: this.title.trim(),
        beginningDate: this.beginningDate,
        department: this.department,
        metadata: {
          classMode: this.classMode,
        },
      }
    },
  },
  created() {
    this.resetDefault()
  },
  watch: {
    classData() {
      this.resetDefault()
    },
  },
}
</script>
